<!-- @format -->

<div
	class="hmf-h-100 hmf-w-100 hmf-px-s hmf-flex-display hmf-flex-column hmf-justify-content-center hmf-align-items-center hmf-text-align-center hmf-align-self-stretch">
	<h1 class="hmf-header-bold-xl hmf-mb-xs">
		{{ canRetryApiCall() ? 'We’re having trouble' : 'Still not working' }}
	</h1>
	<p class="hmf-body-l hmf-mb-l">
		{{
			canRetryApiCall()
				? 'Something went wrong while loading. Please try again or continue browsing.'
				: 'We tried again, but it’s still not loading. Please check your connection or try again later.'
		}}
	</p>

	<div class="button-group hmf-flex-display hmf-flex-column">
		@if (canRetryApiCall()) {
			<button
				hmf-button
				[variant]="'primary'"
				[label]="'try-again'"
				(click)="onTryAgainClick()">
				TRY AGAIN
			</button>
		}
		<button
			hmf-button
			[variant]="canRetryApiCall() ? 'secondary' : 'primary'"
			[label]="'continue-browsing'"
			(click)="onContinueBrowsing()">
			CONTINUE BROWSING
		</button>
	</div>
</div>
